import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Drawer from '@mui/material/Drawer';
import Select from "react-select";
import { Button } from "react-bootstrap";
import DatePickerWrapper from "../../../components/Forms/Pickers/DatePicker";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav, Badge, Dropdown } from "react-bootstrap";
import DatePicker, { DateObject } from "react-multi-date-picker";

import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import delivery from '../../../../images/delivery.jpg';

const Tripsheet = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const [hasFetched, setHasFetched] = useState(false);
    const [selectedPoint, setSelectedPoint] = useState(0);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedPoints, setSelectedPoints] = useState(['0']); // Default to "Over All" selected

    const [branch_option, setBranchOption] = useState([]);
    const [branch, setBranch] = useState(branch_id);
    useEffect(() => {
        axios.get(`${baseURL}/dropdown/branch`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.branch_name,
                }));
                setBranchOption(formatted);
                // setBranch(formatted[0]);
            })
            .catch(error => {
                console.log('There was an error fetching the posts!', error);
            });
    }, []);

    const [optionsSchedule, setOptionsSchedule] = useState([]);
    const [schedule, setSchedule] = useState(null);
    useEffect(() => {
        const fetchSchedules = async () => {
            try {
                const response = await axios.get(`${baseURL}/item-schedule/items/active`);
                if (response.status === 200 && response.data.data) {
                    const schedules = response.data.data.map(item => ({
                        value: item.sno,
                        label: item.itemschedule_name,
                    }));
                    setOptionsSchedule(schedules);
                    // setSchedule(schedules[schedules.length - 1]);
                }
            } catch (error) {
                console.error('Error fetching schedules:', error);
            }
        };

        fetchSchedules();
    }, []);

    const [dpoption, setdpoption] = useState([]);
    const [dp, setdp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/getdp/${branch_id}`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.name,
                }));
                setdpoption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [products, setProducts] = useState([]);
    const [delivery_details, setDeliverydetail] = useState([]);
    const [date, setDate] = useState(null);
    const [datas, setData] = useState([]);
    const [isHoliday, setIsHoliday] = useState(false);

    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch: branch_id,
            dp: dp,
            date: selectedDate,
        };
        axios.get(`${baseURL}/delivery/products_subscribers/${schedule.value}`, { params: params })
            .then(response => {
                setProducts(response.data.products);
                setDeliverydetail(response.data.subscribers);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setDate(response.data.date);
                setData(response.data);
                setSelectedDate(response.data.date);
                setHasFetched(true);
                if (response.data.is_holiday === 1) {
                    setIsHoliday(true);
                } else {
                    setIsHoliday(false);
                }
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });

        axios.get(`${baseURL}/delivery/generate/${schedule.value}`, { params: params })
            .then(response => {
                //
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                // setHasFetched(true);
            });
    };

    const handleDPChange = (selectedOptions) => {
        const ids = selectedOptions.map(option => option.value).join(','); // converts to "1,5,9"
        setdp(ids);
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!schedule) {
            newErrors.schedule = "This Field is Required.";
        }

        if (!branch) {
            newErrors.branch = "This Field is Required.";
        }

        if (!selectedDate) {
            newErrors.date = "This Field is Required.";
        }

        // if (!dp) {
        //     newErrors.dp = "This Field is Required.";
        // }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors(validationErrors);

        fetchData();
    };

    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if (hasFetched) {
                if (!$.fn.dataTable.isDataTable(table)) {
                    $(table).DataTable({
                        "responsive": true,
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        });
    }, [hasFetched]);

    const [key, setKey] = useState(null);

    useEffect(() => {
        if (products.length > 0) {
            setKey(products[0].sno.toString());  // convert to string to match eventKey type
        }
    }, [products]);

    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState('');

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleDateChange = (dateValue) => {
        setCustomSTDTFilValue(dateValue);
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
            const formattedDate = dateValue.format('YYYY-MM-DD');
            setSelectedDate(formattedDate);
        } else {
            setSelectedDate(null);
        }
    };

    // ------------------------------------------------------------------------ Export -------------------------------------------------

    const exportCSV = async () => {
        try {

            const params = {
                product_id: key,
                branch: branch_id,
                dp: selectedPoint,
                date: date,
            };

            const response = await axios.get(`${baseURL}/delivery/print`, { params });
            const allData = response.data.subscribers;

            const columnNames = [
                'S.No', 'Customer', 'Contact', 'Area', 'Address',
                'Package Count'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Customer': item.person_name,
                'Contact': item.person_contact,
                'Area': item.area_name,
                'Address': item.address,
                'Package Count': item.product_count || '-',
            }));
            const csv = Papa.unparse({
                fields: columnNames,
                data: formattedData
            });

            const title = 'Trip sheet report'; // You can make this dynamic
            const product = response.data.productName;
            const dp = response.data.delivery_point_name.join(', ');
            // csv = `${title}\n${csv}`;

            // Create CSV download
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'tripsheet.csv';
            link.click();
        } catch (error) {
            console.log('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const exportExcel = async () => {
        try {

            const params = {
                product_id: key,
                branch: branch_id,
                dp: selectedPoint,
                date: date,
            };

            const response = await axios.get(`${baseURL}/delivery/print`, { params });
            const allData = response.data.subscribers;

            const columnNames = [
                'S.No', 'Customer', 'Contact', 'Area', 'Address',
                'Package Count'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Customer': item.person_name,
                'Contact': item.person_contact,
                'Area': item.area_name,
                'Address': item.address,
                'Package Count': item.product_count || '-',
            }));
            // Create worksheet from formatted data
            const ws = XLSX.utils.json_to_sheet(formattedData);

            // Create a new workbook and append the worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            // Write the workbook to an Excel file and trigger the download
            XLSX.writeFile(wb, 'tripsheet.xlsx');
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const subscribersByProduct = products.map(product => ({
        ...product,
        subscribers: delivery_details.filter(sub => sub.product_name === product.product_name)
    }));

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Trip Sheets</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Delivery Management</li>
                    </ol>
                </div>
                {/* <div className='d-flex'>
                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className='me-2'><i className="fa-solid fa-circle-down fs-8"></i></span>
                            <span className='fw-bold'>Export</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={exportCSV}><label className='text-black'>
                                <span><i className="fa-solid fa-file-csv me-2 fs-4"></i></span>CSV
                            </label></Dropdown.Item>
                            <Dropdown.Item onClick={exportExcel}><label className='text-black'>
                                <span><i className="fa-solid fa-file-excel me-2 fs-4"></i></span>Excel
                            </label></Dropdown.Item>
                            <Dropdown.Item href={`/trip-sheet-print?branch_id=${branch_id}&&schedule_id=${schedule ? schedule.value : null}&&date=${selectedDate}&&product_id=${key}&&delivery_point=${selectedPoints.join(',')}`}><label className='text-black'>
                                <span><i className="fa-solid fa-print me-2 fs-4"></i></span>Print
                            </label></Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div> */}
            </div>

            <Row className='mb-4'>
                <Col xl={3} className='mb-3'>
                    <div className='col-lg-12'>
                        <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                        <div className='datepicker-wrapper d-flex'>
                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                            <DatePicker placeholder='Select Date'
                                value={custom_stdt_fil_value}
                                onChange={handleDateChange}
                                format="DD-MM-YYYY"
                            />
                        </div>
                        {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                    </div>
                </Col>
                <Col xl={3} >
                    <div>
                        <label className="text-black font-w500 fs-7">Schedule<span className="required">*</span></label>
                        <Select
                            placeholder="Select Schedule"
                            options={optionsSchedule}
                            value={schedule}
                            onChange={setSchedule}
                        />
                        {errors.schedule && <div className="text-danger fs-8 mt-1">{errors.schedule}</div>}
                    </div>
                </Col>
                <Col xl={3} >
                    <div>
                        <label className="text-black font-w500 fs-7">Delivery Point<span className="required">*</span></label>
                        <Select placeholder={'Select Delivery Point'}
                            options={dpoption}
                            isMulti
                            onChange={handleDPChange}
                        />
                        {errors.dp && <div className="text-danger fs-8 mt-1">{errors.dp}</div>}
                    </div>
                </Col>

                <Col xl={3} className='mb-3 align-content-center'>
                    <div className='col-lg-3 mt-4 d-flex align-items-center justify-content-start gap-1'>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleSubmit} >
                            <span className='font-w400'>Generate</span>
                        </Button>
                        {delivery_details.length > 0 && (
                            <Button className="me-2 btn-sm" variant="primary" href={`/trip-sheet-print?branch_id=${branch_id}&&schedule_id=${schedule ? schedule.value : null}&&date=${selectedDate}&&delivery_point=${dp}`}>
                                <span className='font-w400'>Print</span>
                            </Button>
                        )}
                    </div>

                </Col>

                <Col xl={12} className='mb-3'>
                    {hasFetched ? (
                        <div className="custom-tab-1">
                            {products.length > 0 ? (
                                <>
                                    {isHoliday ? (
                                        <div className='align-content-center' style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            paddingTop: '10%',
                                            // height: '100vh',       // full viewport height
                                            color: 'red',          // text-danger equivalent
                                            fontSize: '24px',      // increase font size
                                            fontWeight: 'bold'     // optional for emphasis
                                        }}>
                                            <label>Holiday</label>
                                        </div>
                                    ) : (
                                        <Row>
                                            <Col xl={12}>
                                                <div className="table-container">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        {/* Show entries */}
                                                        <div>
                                                            <label className="me-2">Show</label>
                                                            <select
                                                                className="form-select d-inline w-auto"
                                                                style={{ fontSize: '0.85rem', height: '30px' }}
                                                                value={perPage}
                                                                onChange={(e) => {
                                                                    setPerPage(Number(e.target.value));
                                                                    setPage(1);
                                                                }}
                                                            >
                                                                <option value={10}>10</option>
                                                                <option value={25}>25</option>
                                                                <option value={50}>50</option>
                                                                <option value={100}>100</option>
                                                            </select>
                                                        </div>

                                                        {/* Search */}
                                                        <div>
                                                            <input
                                                                type="text"
                                                                style={{ fontSize: '0.85rem', height: '40px' }}
                                                                placeholder="Search..."
                                                                className="form-control"
                                                                value={searchTerm}
                                                                onChange={(e) => {
                                                                    setSearchTerm(e.target.value);
                                                                    setPage(1);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                        <thead>
                                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                                <th className='min-w-50px text-start'>S.No</th>
                                                                <th className='min-w-100px'>Customer</th>
                                                                <th className='min-w-100px'>Contact</th>
                                                                <th className='min-w-125px'>Area</th>
                                                                <th className='min-w-100px text-center'>Address</th>
                                                                <th className='min-w-125px text-center'>Package Count</th>
                                                                <th className='min-w-125px text-center'>Product</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {delivery_details.length === 0 ? (
                                                                <tr>
                                                                    <td colSpan="7" className="text-center text-muted py-2">No data available</td>
                                                                </tr>
                                                            ) : (
                                                                delivery_details
                                                                    .filter(sub => sub.person_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                                                        sub.area_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                                                        sub.address.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                                                        sub.product_name.toLowerCase().includes(searchTerm.toLowerCase()))
                                                                    .slice((page - 1) * perPage, page * perPage)
                                                                    .map((sub, index) => (
                                                                        <tr key={sub.subscription_id}>
                                                                            <td className='text-start text-black'>{index + 1 + (page - 1) * perPage}</td>
                                                                            <td className='text-black'>{sub.person_name}</td>
                                                                            <td className='text-black'>{sub.person_contact}</td>
                                                                            <td className='text-black'>{sub.area_name}</td>
                                                                            <td className='text-black'>{sub.address}</td>
                                                                            <td className='text-center'>
                                                                                <Badge bg="info" className='text-white fs-8 py-0 px-1'>
                                                                                    {sub.product_count.toString().padStart(2, '0')}
                                                                                </Badge>
                                                                            </td>
                                                                            <td className='text-center text-black'>{sub.product_name}</td>
                                                                        </tr>
                                                                    ))
                                                            )}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan="5" className='text-end text-black font-w500 fs-4'>Overall Package Count</td>
                                                                <td className='text-center'>
                                                                    <label className='text-danger fw-bold fs-3'>
                                                                        {delivery_details.reduce((sum, s) => sum + s.product_count, 0).toString().padStart(2, '0')}
                                                                    </label>
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>

                                                    {/* Pagination */}
                                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                                        <div>
                                                            {delivery_details.length > 0 ? (
                                                                <span className="text-muted">
                                                                    Showing {(page - 1) * perPage + 1} to {Math.min(page * perPage, delivery_details.length)} of {delivery_details.length} entries
                                                                </span>
                                                            ) : (
                                                                <span className="text-muted">Showing 0 to 0 of 0 entries</span>
                                                            )}
                                                        </div>
                                                        <nav>
                                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                                </li>
                                                                {[...Array(Math.ceil(delivery_details.length / perPage))].map((_, i) => (
                                                                    <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                                    </li>
                                                                ))}
                                                                <li className={`page-item ${page === Math.ceil(delivery_details.length / perPage) ? 'disabled' : ''}`}>
                                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>

                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </>
                            ) : (
                                <div className='align-content-center' style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    paddingTop: '10%',
                                    // height: '100vh',       // full viewport height
                                    color: 'red',          // text-danger equivalent
                                    fontSize: '24px',      // increase font size
                                    fontWeight: 'bold'     // optional for emphasis
                                }}>
                                    <label>No Products Available</label>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="text-center mt-2">
                            {/* <img src={delivery} className='h-350px mt-4' alt="delivery" /> */}
                        </div>
                    )}
                </Col>
            </Row>

        </>
    )


}
export default Tripsheet;